module.exports = __webpack_public_path__ + "img/jackpot-lucky-draw.4c4c1c9c.svg";